import { render, staticRenderFns } from "./scratchWorksPlay.vue?vue&type=template&id=32f88785&scoped=true&"
import script from "./scratchWorksPlay.vue?vue&type=script&lang=js&"
export * from "./scratchWorksPlay.vue?vue&type=script&lang=js&"
import style0 from "./scratchWorksPlay.vue?vue&type=style&index=0&id=32f88785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f88785",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f88785')) {
      api.createRecord('32f88785', component.options)
    } else {
      api.reload('32f88785', component.options)
    }
    module.hot.accept("./scratchWorksPlay.vue?vue&type=template&id=32f88785&scoped=true&", function () {
      api.rerender('32f88785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scratchWorksPlay/scratchWorksPlay.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/scratchWorksPlay/scratchWorksPlay.vue
// module id = A7Zz
// module chunks = 0